import React from 'react';

import ProgressLegendItem from './ProgressLegendItem/ProgressLegendItem';
import getSortedDataLegends from '../helpers/getSortedDataLegends';
import parseMaximumLegend from '../helpers/parseMaximumLegend';

import { LegendFormatType, SizeType } from '../Progress';
import { ProgressLegendEntry, ProgressLegendWrapper } from '../styles';

export interface LabelDataLegend {
  color: string;
  label?: string;
  value: number;
}

export interface LabelMaximumLegend {
  label?: string;
  value: number;
}

export interface ProgressLegendProps {
  dataLegends: Array<Node> | Array<LabelDataLegend>;
  maximumLegend: Node | LabelMaximumLegend;
  size: SizeType;
  legendFormat: LegendFormatType;
}

/**
 * @purpose Legend showing parts of a progress bar
 */
function ProgressLegend({ size, dataLegends, maximumLegend, legendFormat }: ProgressLegendProps) {
  const sortedDataLegends = getSortedDataLegends(dataLegends);
  const parsedMaximumLegend = parseMaximumLegend(maximumLegend);

  const data = [...sortedDataLegends, parsedMaximumLegend];

  const renderItems = () =>
    data.map((datum, index) => (
      <ProgressLegendEntry key={`${index}`}>
        {datum.hasOwnProperty('value') ? (
          <ProgressLegendItem {...datum} size={size} valueFormat={legendFormat} />
        ) : (
          datum
        )}
      </ProgressLegendEntry>
    ));

  return <ProgressLegendWrapper>{renderItems()}</ProgressLegendWrapper>;
}

export default ProgressLegend;
